import { combineReducers } from 'redux'
import { combineEpics } from 'redux-observable'
import { reducer as formReducer } from 'redux-form'
import { loginEpic, logoutEpic, loginFulfilledEpic } from './loginEpic'
import { updateMapEpic } from './mapEpic'
import {
  setNewTimeEpic,
  updateTimestampEpic,
  setAdvancedTimeEpic,
  updateTimestampValueEpic,
  updateSeasonEpic,
  updateMinMaxTimeEpic
} from './timestampEpic'
import { updateServiceEpic, serviceCardMountedEpic } from './serviceEpic'
import { copyJwtToClipboardEpic, copyStoreToClipboardEpic } from './debugEpic'
import { dataEpic, pointDataEpic } from './dataEpic'
import { updateWeatherEpic } from './weatherEpic'
import { updateLayerEpic } from './layerEpic'

export const rootEpic = (action$, store) =>
  combineEpics(
    copyJwtToClipboardEpic,
    copyStoreToClipboardEpic,
    dataEpic,
    pointDataEpic,
    loginEpic,
    logoutEpic,
    loginFulfilledEpic,
    serviceCardMountedEpic,
    setNewTimeEpic,
    setAdvancedTimeEpic,
    updateTimestampValueEpic,
    updateMapEpic,
    updateTimestampEpic,
    updateMinMaxTimeEpic,
    updateServiceEpic,
    updateWeatherEpic,
    updateLayerEpic
  )(action$, store)

export const rootReducer = combineReducers({
  chart: require('./chartRedux').reducer,
  click: require('./clickRedux').reducer,
  data: require('./dataRedux').reducer,
  debug: require('./debugRedux').reducer,
  form: formReducer,
  layer: require('./layerRedux').reducer,
  login: require('./loginRedux').reducer,
  map: require('./mapRedux').reducer,
  mouse: require('./mouseRedux').reducer,
  notification: require('./notificationRedux').reducer,
  object: require('./objectRedux').reducer,
  service: require('./serviceRedux').reducer,
  serviceCard: require('./serviceCardRedux').reducer,
  streetview: require('./streetviewRedux').reducer,
  table: require('./tableRedux').reducer,
  timestamp: require('./timestampRedux').reducer,
  timeSlider: require('./timeSliderRedux').reducer,
  upload: require('./uploadRedux').reducer,
  weather: require('./weatherRedux').reducer
})



// WEBPACK FOOTER //
// ./src/redux/root.js